<template>
  <div class="text-center pt-[100px]">
    <Resource :src="getFeUrl('/youyan-platform/png/loading.png')" class="h-[130px]"></Resource>
    <div>正在跳转至视频创作平台，请稍等</div>
  </div>
</template>
<script lang="ts" setup>
import { authThird } from '~/api';
import { getFeUrl } from '~/utils/url';

const route = useRoute();
const requestURL = useRequestURL();
const { setSession } = useChangeUser();

onMounted(async () => {
  await useLoginOut(true);

  if (route.query.auth_session) {
    const { auth_session } = route.query;

    const { data } = await authThird(
      {
        auth_session: auth_session as string,
      },
      {
        credential: false,
      },
    );

    await setSession(data);

    const query_open_type = route.query.open_type ? `?open_type=${route.query.open_type}` : '';

    const redirectUrl = `${requestURL.origin}/workspace${query_open_type}`.replace(
      'http://',
      'https://',
    );

    console.debug('redirect', redirectUrl, requestURL);

    location.replace(redirectUrl);
  }
});
</script>
<style lang="scss" scoped></style>
